import { ReactNode } from "react";
import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";

interface LegalSectionProps {
  title: string;
  children: ReactNode;
}

export function LegalSection({ title, children }: LegalSectionProps) {
  return (
    <section>
      <h2 className="text-xl md:text-2xl font-bold text-foreground-950 tracking-tight mb-3">
        {title}
      </h2>
      <div className="space-y-3 text-sm md:text-base text-foreground-700 leading-relaxed">
        {children}
      </div>
    </section>
  );
}

interface LegalShellProps {
  title: string;
  subtitle: string;
  description: string;
  lastUpdated: string;
  documentLabel: string;
  children: ReactNode;
}

export default function LegalShell({
  title,
  subtitle,
  description,
  lastUpdated,
  documentLabel,
  children,
}: LegalShellProps) {
  return (
    <Layout>
      <PageHero
        title={title}
        subtitle={subtitle}
        description={description}
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page max-w-4xl mx-auto">
          <div className="bg-accent-50 border border-accent-200 rounded-lg p-5 mb-8" role="note">
            <div className="flex items-start gap-3">
              <i className="ri-draft-line text-accent-600 text-xl mt-0.5 shrink-0" aria-hidden="true"></i>
              <p className="text-sm text-accent-800 leading-relaxed">
                <span className="font-bold">Draft — for review.</span> This document is a draft prepared for review by qualified
                legal and accessibility professionals before production publication. It does not constitute legal advice and should
                not be relied upon as such.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-b border-background-200/80 pb-4 mb-10">
            <p className="text-xs uppercase tracking-wider text-foreground-500 font-semibold">
              {documentLabel}
            </p>
            <p className="text-xs text-foreground-500">
              Last updated: {lastUpdated}
            </p>
          </div>

          <div className="space-y-10">
            {children}
          </div>
        </div>
      </section>
    </Layout>
  );
}